import { FC, useState } from 'react';
import { useOpenId } from '@entities/OpenIDProvider';
import { Avatar, Button } from '@shared/UI';
import './UserInfo.scss';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import classNames from 'classnames';

export const UserInfo: FC = () => {
    const { logout, user } = useOpenId();

    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <div className='widget-user-info'>
                <Avatar
                    src={user?.picture}
                    firstName={user?.given_name}
                    lastName={user?.family_name}
                    className='widget-user-info__avatar'
                />
                <div className='widget-user-info__name'>
                    <h3>
                        {user?.given_name} {user?.family_name}
                    </h3>
                    <div
                        className='username-text'
                        title={user?.preferred_username}
                    >
                        {user?.preferred_username}
                    </div>
                </div>
                <div
                    onClick={() => setExpanded((prev) => !prev)}
                    className='widget-user-info__arrow'
                >
                    {expanded ? <BiChevronUp /> : <BiChevronDown />}
                </div>
            </div>
            <div className={classNames('widget-user-info__logout', { expanded })}>
                <Button
                    onClick={() => {
                        logout();
                        localStorage.removeItem('User');
                    }}
                >
                    Logout
                </Button>
            </div>
        </>
    );
};
